import axios from "axios";
import axiosJwtInterceptor from "./axiosJwtInterceptor";
import axiosErrorInterceptor from "./axiosErrorInterceptor";
import axiosSuccessInterceptor from "./axiosSuccessInterceptor";

const http = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}`,
  headers: {
    "Content-type": "application/json",
  },
});

http.interceptors.request.use(axiosJwtInterceptor, (e) => Promise.reject(e));

http.interceptors.response.use(
  (response) => axiosSuccessInterceptor(response),
  (error) => axiosErrorInterceptor(error)
);

export default http;
